import React, { useEffect, useState } from 'react'
import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'
import rtlPlugin from 'stylis-plugin-rtl'
import { useTranslation } from 'react-i18next'
import NavBar from './NavBar'
import { ThemeProvider } from '@mui/material/styles'
import theme from '../Components/Theme'
import Categorisation from '../containers/categorisation'
import CurrentAccount from './CurrentAccount'
import Calendar from '../containers/Time'
// import CategorizationTable from "../Components/CategorizationTable";
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom'
import ManageCategories from '../Components/ManageCategories'
import HomePage from '../containers/HomePage'
import MesComptes from '../containers/mesComptes'
import Catalogue from '../containers/catalogue'
import MainPageFiState from '../containers/fiStatement/MainFiStat'
import MainDashBoard from '../containers/DashBoard/MainBoard'
import SyntheseTemps from '../containers/SyntheseTemps/MainBoard'
import { AppContext } from '../context'
import DashboardDetail from '../containers/fiStatement/DashboardDetail'
import { GestionOperations } from '../containers/GestionOperations'
import { PlanEntretien } from '../containers/Domicile/PlanEntretien'
import { EntretienDetails } from '../containers/Domicile/PlanEntretien/EntretienDetails'
import { MesVehicules } from '../containers/Domicile/MesVehicules'
import { VehicleDetails } from '../containers/Domicile/MesVehicules/VehicleDetails'
import { HistoriqueVHkm } from '../containers/Domicile/MesVehicules/VehicleDetails/HistoriqueVHkm'
import { HistoriqueValo } from '../containers/Domicile/MesVehicules/VehicleDetails/HistoriqueValo'
import { Financement } from '../containers/Domicile/MesVehicules/VehicleDetails/Financement'
import { ImmoFinancement } from '../containers/Domicile/MonImmobilier/DocumentDetails/ImmoFinancement'
import { DetailDepense } from '../containers/Domicile/MesVehicules/VehicleDetails/DetailDepense'
import { MesOjectifs } from '../containers/MesObjectifs'
import { DocumentDetails } from '../containers/Domicile/MonImmobilier/DocumentDetails'
import { MonImmobilier } from '../containers/Domicile/MonImmobilier'
import { MesDocuments } from '../containers/MesDocuments'
import { MesContacts } from '../containers/MesContacts'
import { MaBucketList } from 'containers/Personnal/BucketList'
import { ImmoValue } from 'containers/Domicile/MonImmobilier/DocumentDetails/ImmoValue'
import { ImmoDetailDepense } from '../containers/Domicile/MonImmobilier/DocumentDetails/ImmoDetailDepense'
import { MonParcoursPro } from '../containers/Pro/MonParcoursPro'
import { Mesplantes } from '../containers/Garden'
import PlantDetail from '../containers/Garden/PlantView'
import Search from './Search'
// import {DashBoard} from 'containers/DashBoard'
// import ScrollToTop from './ScrollToTop'
import { ExperienceDetails } from 'containers/Pro/MonParcoursPro/ExperienceDetails'
import { FormationDetails } from '../containers/Pro/MonParcoursPro/FormationDetails'
import { MesToDo } from '../containers/MesToDo'
import { MesRecettes } from '../containers/Personnal/MesRecettes'
import { RecettesCategory } from 'containers/Personnal/RecettesCategory'
import { RecetteDetails } from '../containers/Personnal/MesRecettes/RecetteDetails'
import { RecetteCatalog } from '../containers/Personnal/RecetteCatalog'
import Menu from '../containers/Personnal/PlanMeal'
// import { Box } from '@mui/material'
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import MonBudget from '../containers/MonBudget'
import MonPatrimoine from '../containers/MonPatrimoine/MainBoard'
import { useLocation } from 'react-router-dom'
import Login from '../containers/auth/Login'
import Register from 'containers/auth/Register'
import { ProtectedRoute, ProtectedRoute1 } from './ProtectedRoutes'
import Verify from '../containers/auth/Verify'
import ResetPassword from 'containers/auth/ResetPassword'
import PolicyViewer from '../containers/legal/PolicyViewer'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import StoreProvider from '../reduxLib/StoreProvider'
import OpenBank from './OpenBank'
import { useSelector } from 'react-redux'
import UserWizardPage from './UserWizardPage'
import DefinirObjective from './DefinirObjective'
import GeneralReport from './LifeReports/GeneralReport'
import GeneralReportEnhanced from './LifeReports/GeneralReportEnhanced'
import DomainDetailPage from './LifeReports/DomainDetailPage'
import NotFound from './NotFound'
import ATestPage from './ATestPage'
import GoogleAuth from './GoogleAuth'
import Opportunities from 'containers/Opportunities'
import MyInbox from '../containers/MyInbox'
import Shopping from 'containers/Shopping'
import Roadmap from 'containers/Roadmap'
import SubscriptionPlanModal from './SubscriptionPlanModal'
import { Box } from '@mui/material'
import SyntheseProfessionnelle from '../containers/SyntheseProfessionnelle/MainBoard'
import { TempsDeTravail } from '../containers/Pro/TempsDeTravail'
import Investments from '../containers/Investments'
// LAP-550 V1.2 — pages détail (drill-down)
import EvolutionDetail from '../containers/Investments/Portfolio/details/EvolutionDetail'
import RepartitionDetail from '../containers/Investments/Portfolio/details/RepartitionDetail'
import PortfolioDetailPage from '../containers/Investments/Portfolio/details/PortfolioDetail'
import OpportunitiesDetail from '../containers/Investments/Portfolio/details/OpportunitiesDetail'
import CoachDetail from '../containers/Investments/Portfolio/details/CoachDetail'
import MarketDetail from '../containers/Investments/Markeet/details/MarketDetail'
import AssetDetail from '../containers/Investments/Markeet/details/AssetDetail'
import SocialDashboard from '../containers/SocialDashboard' // LAP-646
import { ConseillerPatrimonialPage } from '../containers/ConseillerPatrimonial'
// Module Santé — copilote santé personnel (cf. CDC « LIFE APP — Module Santé »)
import { SanteModule } from '../containers/Sante'
// Module Contrats — contrats du foyer + interprétation IA des factures
import { ContratsModule } from '../containers/Contrats'
// Module Life Performance — Fitness OS (consomme le module Santé)
import { PerformanceModule } from '../containers/Performance'
// LAP-765 — Conseiller Temps IA (maître du temps)
import { ConseillerTempsPage } from '../containers/ConseillerTemps'
// LAP-766 — Conseiller Écologie IA (empreinte carbone)
import { ConseillerEcologiePage } from '../containers/ConseillerEcologie'
// LAP-767 — Conseiller Pro / Formation IA (employabilité)
import { ConseillerProPage } from '../containers/ConseillerPro'
// LAP-768 — Conseiller Social / Relationnel IA
import { ConseillerSocialPage } from '../containers/ConseillerSocial'
// LAP — Conseiller en Organisation IA (todo : profil d'organisation, domaines, projets)
import { ConseillerOrganisationPage } from '../containers/ConseillerOrganisation'
// Life Intelligence — chat IA généraliste multi-domaines (bouton du header
// de la page d'accueil).
import { LifeIntelligencePage } from '../containers/LifeIntelligence'
// Tax Intelligence Engine — Tax Center (position fiscale, opportunités,
// calendrier, justificatifs, simulations What-if, copilot)
import { TaxCenterPage } from '../containers/TaxCenter'
// GE023 — Découverte locale (événements locaux recommandés)
import EventDetail from '../containers/Discovery/EventDetail'
import Preferences from '../containers/Discovery/Preferences'
import Changes from '../containers/Discovery/Changes'
import EventsList from '../containers/Discovery/EventsList'
// GE-CAPPS — Apps custom utilisateur (specs construites via le MCP Claude)
import { MyApps, AppRunner } from '../containers/CustomApps'
import Subscription from './Subscription'
import SubscriptionSuccess from './SubscriptionSuccess'
import AccessDenied from 'AccessDenied'
import { AppAccessRoute } from './AppAccessRoute'
// Système de crédits Life — modale globale "Crédits insuffisants" (HTTP 402)
import { InsufficientCreditsModal } from './Billing'
// Shell mobile V3 (app Capacitor / fenêtre étroite) — remplace la NavBar.
// Design validé : DEV/mockup_mobile_navigation_v3.html
import { useIsMobileShell, initNativeUi } from 'utils/mobile'
import {
  SESSION_CLEARED_EVENT,
  isUserLoaded,
  hasSessionToken,
  isPublicAuthPath,
} from 'utils/session'
import MobileShell from './Mobile/MobileShell'
import MobileDomains from './Mobile/MobileDomains'
import MobileProfile from './Mobile/MobileProfile'

const cacheLtr = createCache({ key: 'mui' })
const cacheRtl = createCache({ key: 'muirtl', stylisPlugins: [rtlPlugin] })

const App = () => {
  const { i18n } = useTranslation()
  const [tableAccount, setTableAccount] = useState('')
  const [userSync, setUserSync] = useState(false)
  const location = useLocation()
  const token = localStorage.getItem('token')
  // Contexte mobile (WebView Capacitor ou fenêtre ≤ 768 px) → shell V3
  // (header + tab bar flottante) à la place de la NavBar desktop.
  const isMobileShell = useIsMobileShell()
  const currentLanguage = (i18n.language || 'fr').split('-')[0]
  const isRtl = currentLanguage === 'ar'

  const getCookie = (name) => {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
  }

  // useEffect(() => {
  //   // console.log(path)
  //   // if (path === '/' && !token) {
  //   //   navigate('/login')
  //   // }
  //   console.log('sdfd')
  // }, [])
  useEffect(() => {
    let ap_v = localStorage.getItem('life_app')
    let sp_v = getCookie('life_app')
    if (ap_v && sp_v) {
      if (ap_v !== sp_v) {
        localStorage.setItem('life_app', sp_v)
        window.location.reload()
        return
      }
    } else {
      if (sp_v) {
        localStorage.setItem('life_app', sp_v)
      }
    }
  }, [location])

  useEffect(() => {
    // Natif : barre d'état en texte clair (fonds sombres partout).
    initNativeUi()
  }, [])

  // Toute sortie de session (déconnexion, suppression de compte, token
  // expiré) démonte <AppRouters />. Sans ça, l'arbre applicatif restait monté
  // par-dessus /login avec un user vide, ce qui rouvrait le portillon
  // d'abonnement (modale « Choisir un abonnement » bloquante).
  useEffect(() => {
    const onSessionCleared = () => setUserSync(false)
    window.addEventListener(SESSION_CLEARED_EVENT, onSessionCleared)
    return () => window.removeEventListener(SESSION_CLEARED_EVENT, onSessionCleared)
  }, [])

  useEffect(() => {
    document.documentElement.setAttribute('lang', currentLanguage)
    document.documentElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr')
    document.body.setAttribute('dir', isRtl ? 'rtl' : 'ltr')
  }, [currentLanguage, isRtl])

  const dispatchAccountClick = (actionType, payload) => {
    switch (actionType) {
      case 'CLICK':
        setTableAccount(payload.id)
        return
      default:
        return
    }
  }

  return (
    <AppContext.Provider value={{ tableAccount, dispatchAccountClick }}>
      <CacheProvider value={isRtl ? cacheRtl : cacheLtr}>
        <div style={{ backgroundColor: '#00001d', minHeight: '100vh' }}>
          <ToastContainer rtl={isRtl} />
          {/* <div style={{ backgroundColor: '#00001d', minHeight: '100vh' }}> */}

          {/* <CategorizationTable /> */}

          <ThemeProvider theme={theme}>
            <Routes>
              {/* Public routes for legal policies */}
              <Route path="/legal/policies/:policyType" element={<PolicyViewer />} />
              
              <Route element={<ProtectedRoute1 />}>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/verify/:code" element={<Verify />} />
                <Route path="/reset-password/:code" element={<ResetPassword />} />
              </Route>
            </Routes>
            <StoreProvider>
              {!token ? (
                <AppCheck />
              ) : isMobileShell ? (
                <MobileShell setUserSync={setUserSync} />
              ) : (
                <NavBar setUserSync={setUserSync} />
              )}
              {/* L'arbre applicatif est rendu EN PARALLÈLE des routes
                  publiques ci-dessus : sur /login il ne doit pas être monté du
                  tout, sinon son catch-all et ses modales (portillon
                  d'abonnement, wizard) se superposent à la page de connexion —
                  symptôme observé après une suppression de compte. */}
              {userSync && !isPublicAuthPath(location.pathname) && <AppRouters />}
              {/* Modale globale "Crédits insuffisants" — écoute l'évènement DOM
                  émis par utils/api.js sur HTTP 402. Une seule instance suffit
                  pour toute l'app, quel que soit l'endpoint IA qui a renvoyé
                  402. Cf. spec §4.4. */}
              {token && <InsufficientCreditsModal />}
            </StoreProvider>
          </ThemeProvider>
        </div>
      </CacheProvider>
    </AppContext.Provider>
  )
}

export default App

const AppCheck = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const token = localStorage.getItem('token')
  const path = location.pathname

  useEffect(() => {
    if (
      path.startsWith('/login') ||
      path.startsWith('/register') ||
      path.startsWith('/verify/') ||
      path.startsWith('/reset-password/') ||
      path.startsWith('/legal/policies/')
    ) {
    } else {
      if (!token) {
        navigate('/login')
      }
    }
  }, [path, token, navigate])
  return <>.</>
}
const AppRouters = () => {
  const siteUser = useSelector((store) => store.user)
  const routerLocation = useLocation()
  const [completed, setCompleted] = useState(false)
  const [wStep, setWSetp] = useState('')

  useEffect(() => {
    // first_login_completed: true = onboarding done, false/undefined = show wizard
    const firstLoginCompleted = siteUser.user?.first_login_completed === true

    let checkcompleted = false
    let user_wizard = siteUser.user?.user_wizard
    let step = ''

    if (user_wizard && user_wizard.length > 0) {
      const orderedWizard = [...user_wizard]

      for (let i = 0; i < orderedWizard.length; i++) {
        if (!orderedWizard[i].completed && !orderedWizard[i].skip) {
          step = orderedWizard[i].step
          checkcompleted = false
          break
        }
      }

      if (!step) {
        checkcompleted = true
      }

      if (checkcompleted && firstLoginCompleted) {
        setCompleted(true)
        setWSetp('')
      } else if (step) {
        setWSetp(step)
        setCompleted(false)
      } else if (!firstLoginCompleted) {
        setCompleted(false)
        setWSetp('Welcome')
      } else {
        setCompleted(true)
        setWSetp('')
      }
    } else if (!firstLoginCompleted) {
      // First connection or no wizard data: show Welcome
      setCompleted(false)
      setWSetp('Welcome')
    } else {
      setCompleted(true)
      setWSetp('')
    }
  }, [siteUser])

  // When user has no subscription, block app until they choose a plan (subscription modal first, then onboarding).
  // Le portillon ne doit se déclencher QUE pour un utilisateur réellement
  // connecté et chargé. `setSiteUser({})` (déconnexion, suppression de
  // compte) laisse un objet vide mais truthy : le tester tel quel affichait
  // la modale bloquante « Choisir un abonnement » par-dessus la page
  // d'accueil, sans offre puisque le token venait d'être effacé.
  //
  // Second garde-fou (défense en profondeur) : sur une route publique
  // (/login, /register, /verify/…, /reset-password/…, /legal/policies/…) le
  // portillon ne doit JAMAIS se peindre, quel que soit l'état résiduel du
  // store — un rendu intermédiaire suffisait à faire clignoter la modale
  // par-dessus la page de connexion après une suppression de compte.
  const onPublicPath = isPublicAuthPath(routerLocation?.pathname)
  if (
    !onPublicPath &&
    hasSessionToken() &&
    isUserLoaded(siteUser) &&
    siteUser.user.has_subscription !== true
  ) {
    return (
      <Box sx={{ minHeight: '100vh', width: '100%', bgcolor: '#00001d', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <SubscriptionPlanModal open={true} blocking={true} onClose={() => {}} />
      </Box>
    )
  }
  
  return (
    <>
      <Routes>
        <Route path="/access-denied" element={<AccessDenied />} />
        {/* LAP-739 Bug 3 — /choose-plan now renders the SubscriptionPlanModal as
            a full-screen page so the "Voir les offres" CTA in Life Settings
            actually lands somewhere useful. /subscription kept as a redirect
            alias to preserve historical deep links. */}
        <Route
          path="/choose-plan"
          element={
            <Box sx={{ minHeight: '100vh', width: '100%', bgcolor: '#00001d', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <SubscriptionPlanModal open={true} blocking={false} onClose={() => window.history.back()} />
            </Box>
          }
        />
        <Route path="/subscription" element={<Navigate to="/choose-plan" replace />} />
        <Route path="/payment-success" element={<SubscriptionSuccess />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={
            completed ? <HomePage /> : 
            (!completed && wStep) ? <UserWizardPage step={wStep} /> : 
            <HomePage />
          } />
          <Route path="/open-bankac" element={<OpenBank />} />
          {/* <Route path="/Dashboard" element={<DashBoard />} /> */}
          <Route path="/mescomptes" element={<MesComptes />} />
          <Route path="/compte/:id" element={<CurrentAccount />} />

          <Route path="/categorisation" element={<Categorisation />} />
          <Route path="/Fistatement" element={<MainPageFiState />} />
          <Route path="/Dashboard" element={<AppAccessRoute requiredLien="/Dashboard"><MainDashBoard /></AppAccessRoute>} />

          <Route path="/categorization/managecategories" element={<ManageCategories />} />
          <Route path="/catalogue" element={<Catalogue />} />
          <Route path="/dashboard-detail/:slug" element={<DashboardDetail />} />

          <Route path="/gestionoperations" element={<GestionOperations />} />
          <Route path="/mesobjectifs" element={<MesOjectifs />} />
          <Route path="/domicile/monimmobilier" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><MonImmobilier /></AppAccessRoute>} />
          <Route path="/domicile/monimmobilier/monbien/:id" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><DocumentDetails /></AppAccessRoute>} />
          <Route path="/domicile/entretien" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><PlanEntretien /></AppAccessRoute>} />
          <Route path="/domicile/entretien/:id" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><EntretienDetails /></AppAccessRoute>} />
          <Route path="/domicile/mesvehicules" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><MesVehicules /></AppAccessRoute>} />
          <Route path="/domicile/vehicule/:id" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><VehicleDetails /></AppAccessRoute>} />
          <Route path="/domicile/detaildepense/vehicule/:id" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><DetailDepense /></AppAccessRoute>} />
          <Route path="/domicile/historiquekm/vehicule/:id" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><HistoriqueVHkm /></AppAccessRoute>} />
          <Route path="/domicile/historiquevalo/vehicule/:id" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><HistoriqueValo /></AppAccessRoute>} />
          <Route path="/domicile/immovalue/immobilier/:id" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><ImmoValue /></AppAccessRoute>} />
          <Route path="/domicile/detaildepense/immobilier/:id" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><ImmoDetailDepense /></AppAccessRoute>} />
          <Route path="/domicile/financement/vehicule/:id" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><Financement /></AppAccessRoute>} />
          <Route path="/domicile/financement/immobilier/:id" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><ImmoFinancement /></AppAccessRoute>} />
          <Route path="/search/:id/:q" element={<Search />} />
          {/* Shell mobile V3 — onglets « Domaines » et « Profil » de la
              tab bar (accessibles aussi au desktop, sans en dépendre). */}
          <Route path="/domaines" element={<MobileDomains />} />
          <Route path="/profil" element={<MobileProfile />} />
          {/* <Route path="/domicile/monimmobilier" element={<MonImmobilier />} /> */}
          {/* <Route path="/domicile/monimmobilier/monbien/:id" element={<DocumentDetails />} /> */}
          <Route path="/documents" element={<AppAccessRoute requiredLien="/documents"><MesDocuments /></AppAccessRoute>} />
          <Route path="/MonCalendrier" element={<Calendar />} />
          <Route path="/MesContacts" element={<MesContacts />} />
          <Route path="/BucketList" element={<MaBucketList />} />
          {/* <Route path="/search/:id/:q" element={<Search />} /> */}
          <Route path="/Mesplantes" element={<Mesplantes />} />
          <Route path="/Mesplantes/detail/:id" element={<PlantDetail />} />
          <Route path="/parcourspro" element={<MonParcoursPro />} />
          <Route path="/parcourspro/experience/:id" element={<ExperienceDetails />} />
          <Route path="/parcourspro/formation/:id" element={<FormationDetails />} />
          <Route path="/todos/*" element={<MesToDo />} />
          <Route path="/recette" element={<MesRecettes />} />
          <Route path="/recette/catalogue" element={<RecetteCatalog />} />
          <Route path="/recette/:id" element={<RecetteDetails />} />
          <Route path="/recette-category" element={<RecettesCategory />} />
          <Route path="/Menu" element={<Menu />} />
          <Route path="/syntheseTemps" element={<SyntheseTemps />} />
          <Route path="/Monbudget" element={<MonBudget />} />
          <Route path="/MonPatrimoine" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><MonPatrimoine /></AppAccessRoute>} />
          <Route path="/MonPatrimoine/:questionnaire" element={<AppAccessRoute requiredLien="/domicile/monimmobilier"><MonPatrimoine /></AppAccessRoute>} />
          <Route path="/definir-objective" element={<DefinirObjective />} />
          <Route path="/life-report/general/:m/:y/:q" element={<GeneralReport />} />
          <Route path="/life-resume" element={<GeneralReportEnhanced />} />
          <Route path="/life-resume/domaine/:code" element={<DomainDetailPage />} />
          <Route path="/opportunities" element={<Opportunities />} />
          <Route path="/inbox" element={<MyInbox />} />
          <Route path="/shopping" element={<Shopping />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/professionnelle" element={<SyntheseProfessionnelle />} />
          <Route path="/professionnelle/soft-skills" element={<SyntheseProfessionnelle />} />
          <Route path="/tempsdetravail" element={<TempsDeTravail />} />
          <Route path="/investments" element={<Investments />} />
          {/* LAP-550 V1.2 — drill-down portfolio */}
          <Route path="/investments/portfolio/evolution" element={<EvolutionDetail />} />
          <Route path="/investments/portfolio/repartition" element={<RepartitionDetail />} />
          <Route path="/investments/portfolio/positions" element={<PortfolioDetailPage />} />
          <Route path="/investments/portfolio/opportunities" element={<OpportunitiesDetail />} />
          {/* Coach Portefeuille — brief quantitatif quotidien (lecture seule) */}
          <Route path="/investments/coach" element={<CoachDetail />} />
          {/* LAP-550 V1.2 — drill-down marché (générique avec sub-view) */}
          <Route path="/investments/market/:slug" element={<MarketDetail />} />
          {/* LAP-548 / LAP-550 — fiche détail d'une valeur (segment littéral
              "asset" → prioritaire sur la route dynamique :sub en React Router v6) */}
          <Route path="/investments/market/:slug/asset/:assetId" element={<AssetDetail />} />
          <Route path="/investments/market/:slug/:sub/asset/:assetId" element={<AssetDetail />} />
          <Route path="/investments/market/:slug/:sub" element={<MarketDetail />} />
          {/* Tax Intelligence Engine — Tax Center. Les cartes SmartFeed
              pointent vers /tax-center?section=… (calendar|opportunities|
              documents|details) : la page lit ?section= pour ouvrir le
              bon onglet, trame « filtre dans le lien ». */}
          <Route path="/tax-center" element={<TaxCenterPage />} />
          {/* LAP-646 — Social Dashboard */}
          <Route path="/social-dashboard" element={<SocialDashboard />} />
          {/* Module Santé — onglet Santé de Life App (CDC §4.2) */}
          <Route path="/sante" element={<SanteModule />} />
          {/* Module Contrats — contrats du foyer + interprétation IA des factures */}
          <Route path="/contrats" element={<ContratsModule />} />
          {/* Module Life Performance — Fitness OS (consomme le module Santé) */}
          <Route path="/performance" element={<PerformanceModule />} />
          <Route path="/conseiller-patrimonial" element={<ConseillerPatrimonialPage />} />
          {/* LAP-765 — Conseiller Temps IA, calqué sur le Conseiller Patrimonial. */}
          <Route path="/conseiller-temps" element={<ConseillerTempsPage />} />
          {/* Life Intelligence — chat IA généraliste multi-domaines (accueil). */}
          <Route path="/life-intelligence" element={<LifeIntelligencePage />} />
          {/* LAP-766 — Conseiller Écologie IA, calqué sur le Conseiller Temps. */}
          <Route path="/conseiller-ecologie" element={<ConseillerEcologiePage />} />
          {/* LAP-767 — Conseiller Pro / Formation IA, calqué sur le Conseiller Écologie. */}
          <Route path="/conseiller-pro" element={<ConseillerProPage />} />
          {/* LAP-768 — Conseiller Social / Relationnel IA, calqué sur le Conseiller Pro. */}
          <Route path="/conseiller-social" element={<ConseillerSocialPage />} />
          {/* LAP — Conseiller en Organisation IA (todo), calqué sur le Conseiller Temps. */}
          <Route path="/conseiller-organisation" element={<ConseillerOrganisationPage />} />
          {/* GE023 — Découverte locale (événements recommandés) */}
          <Route path="/discovery/events" element={<EventsList />} />
          <Route path="/discovery/events/:id" element={<EventDetail />} />
          <Route path="/discovery/preferences" element={<Preferences />} />
          <Route path="/discovery/changes" element={<Changes />} />
          {/* GE-CAPPS — Apps custom : liste + catalogue, puis AppRunner générique. */}
          <Route path="/apps" element={<MyApps />} />
          <Route path="/apps/:slug" element={<AppRunner />} />
          {/* Système de crédits : on ne crée PAS de page dédiée — la gestion
              des crédits (solde, achat de packs, historique) est intégrée
              dans la page Abonnement existante. Les anciennes URLs /billing*
              redirigent vers /subscription pour ne pas casser d'éventuels
              liens partagés ou Stripe Checkout success_url historiques. */}
          <Route path="/billing" element={<Navigate to="/subscription" replace />} />
          <Route path="/billing/packs" element={<Navigate to="/subscription" replace />} />
          <Route path="/billing/packs/success" element={<SubscriptionSuccess />} />
          <Route path="/oauth2callback" element={<GoogleAuth />} />
          <Route path="/microsoft" element={<GoogleAuth />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/testpage" element={<ATestPage />} />
        </Route>
      </Routes>
    </>
  )
}
